import React from 'react';
import s from '../../s.module.less';

export default function SectionHeader({ title, action }: { title: React.ReactNode; action?: React.ReactNode }) {
    return (
        <div className={s.wizSectionHeader}>
            <span className={s.wizSectionTitle}>{title}</span>
            {action}
        </div>
    );
}
